import React from "react";
import { AppBar, IconButton, Toolbar } from "@mui/material";
import { Link } from "react-router-dom";
import { ReactComponent as LoginIcon } from "./../../../assets/images/icons/Google SVGs/login.svg";
import { ReactComponent as StethoscopeIcon } from "./../../../assets/images/icons/Google SVGs/stethoscope.svg";
import { ReactComponent as HomeIcon } from "./../../../assets/images/icons/Google SVGs/home.svg";
import { ReactComponent as HomeHealthIcon } from "./../../../assets/images/icons/Google SVGs/home_health.svg";

const Appbar = () => {
  return (
    <AppBar
      position="fixed"
      color=""
      sx={{
        top: "auto",
        bottom: 0,
        zIndex: 1049,
        borderTop: "solid 1px #ced4da",

        boxShadow: "0px -4px 10px 0px #0000000D",
        boxShadow: "0px -1px 4px 0px #0000000D",
      }}
    >
      <Toolbar
        className="btn-group px-12px py-2 fs-14"
        role="group"
        aria-label="Basic example"
      >
        <Link
          className="d-flex nav-link justify-content-center col col-4"
          type="button"
          to="/"
        >
          <div
            className={`d-flex w-100 flex-column align-items-center pb-1 ${
              window.location.pathname === "/"
                ? "color-iso-blue-300 fw-medium"
                : "color-bootstrap-gray-600"
            }`}
          >
            <HomeIcon width={32} height={32} />
            صفحه اصلی
          </div>
        </Link>

        <Link
          className="nav-link d-flex justify-content-center col col-4"
          type="button"
          to="/place-store"
        >
          <div
            className={`d-flex w-100 flex-column align-items-center pb-1 ${
              window.location.pathname === "/place-store"
                ? "color-iso-blue-300 fw-medium"
                : "color-bootstrap-gray-600"
            }`}
          >
            <HomeHealthIcon width={32} height={32} />
            مراکز درمانی
          </div>
        </Link>
        <Link
          className="d-flex nav-link justify-content-center col col-4"
          type="button"
          to="/doctor-store"
        >
          <div
            className={`d-flex w-100 flex-column align-items-center pb-1 ${
              window.location.pathname === "/doctor-store"
                ? "color-iso-blue-300 fw-medium"
                : "color-bootstrap-gray-600"
            }`}
          >
            <StethoscopeIcon width={32} height={32} />
            پزشکان
          </div>
        </Link>
      </Toolbar>
    </AppBar>
  );
};

export default Appbar;
